// assets js
import 'bootstrap';
import AOS from 'aos';

AOS.init();